import { useState, useEffect } from "react";

const cache = { data: null };

export default function useTestimonials() {
    const [reviews, setReviews] = useState(cache.data || []);

    useEffect(() => {
        if (cache.data) return;
        fetch("/testimonials.json")
            .then((res) => {
                if (!res.ok) throw new Error(res.status);
                return res.json();
            })
            .then((data) => {
                cache.data = data;
                setReviews(data);
            })
            .catch(() => {});
    }, []);

    return reviews;
}
